import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ExploreTradingUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.exploreTrading();
    }
}
export default ExploreTradingUseCase;
